/**
 * Centralized environment configuration
 * All environment variables should be accessed through this file
 */

const config = {
  // API Configuration
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1',
  fileUrl: import.meta.env.VITE_FILE_URL || 'http://localhost:8000/public',
  
  // Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mode: import.meta.env.MODE,
};

export default config;
